import React from 'react';
import { getLevelTitle } from '../../utils/gamificationManager';
import { playSound } from '../../utils/soundManager';

const LevelUpModal = ({ newLevel, onClose }) => {
  const { title, color, icon } = getLevelTitle(newLevel);

  const handleClose = () => {
    playSound('success');
    onClose();
  };

  return (
    <div className="level-up-overlay" onClick={handleClose}>
      <div className="level-up-modal" onClick={(e) => e.stopPropagation()}>
        <div className="level-up-icon">{icon}</div>
        <h1 className="level-up-title" style={{ color }}>
          LEVEL {newLevel}!
        </h1>
        <p className="level-up-message">
          You've reached <strong>{title}</strong>!
        </p>
        <button className="level-up-button" onClick={handleClose}>
          Awesome!
        </button>
      </div>
    </div>
  );
};

export default LevelUpModal;
